import { jsx as _jsx } from "theme-ui/jsx-runtime";
import sizes from "./sizes";
/**
 * An edit icon.
 * Used for editing tasting notes for example.
 *
 * @param {object} props
 * @param {string} [props.className]
 * @param {import('./sizes').IconSize} [props.size] The icon size.
 */
export default function EditIcon({ className, size = "xsmall" }) {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: "middle",
        }, className: className, viewBox: "0 0 20 20", children: _jsx("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1", children: _jsx("g", { fill: "currentColor", children: _jsx("path", { d: "M8.534 9.413l-.642 2.405 2.277-.604 8.31-8.232-1.774-1.774-8.17 8.205zM11 2v1H2v15h15V9h1v9a1 1 0 01-1 1H2a1 1 0 01-1-1V3c0-.551.448-1 1-1h9zm5.703-2c.134 0 .261.053.354.147l2.484 2.483a.5.5 0 01-.002.708l-8.762 8.68a.486.486 0 01-.223.128l-3.239.861a.498.498 0 01-.611-.613l.898-3.368a.521.521 0 01.13-.224L16.348.147A.505.505 0 0116.703 0z" }) }) }) }));
}
//# sourceMappingURL=EditIcon.js.map